/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class IntegratedToolAccount {
    getFixupPrototypeFunction() { return IntegratedToolAccount.fixupPrototype; }

    static newInstance(model: Partial<IntegratedToolAccount>): IntegratedToolAccount {
        let obj = Object.assign(new IntegratedToolAccount(), model);
        IntegratedToolAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<IntegratedToolAccount>): IntegratedToolAccount {
        if (!model) return null;
        return IntegratedToolAccount.newInstance(<IntegratedToolAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: IntegratedToolAccount) {
        if (!obj) return;

        models.IntegratedToolAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: IntegratedToolAccount): boolean {
        Object.setPrototypeOf(obj, IntegratedToolAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Tool Account ID
     */
    id: string;

}
